import React, { ReactElement } from "react";
import { Box, BoxProps } from "theme-ui";
import { Variants } from "../..";

type CardVerticalProps = {
  image: string | undefined;
  alt: string | undefined;
  link: string | undefined;
} & BoxProps;

export const CardVertical = ({
  image,
  alt,
  link,
  children,
  ...props
}: CardVerticalProps): ReactElement => {
  const linkUrl = link || "";
  return (
    <Box variant="cards.vertical.default" {...props}>
      <Variants.Link
        sx={{ cursor: link ? "pointer" : "default", width: "100%" }}
        href={linkUrl}
      >
        <Box variant="cards.vertical.wrapper">
          <Variants.ImageCardVertical src={image} loading="lazy" alt={alt} />
        </Box>
      </Variants.Link>
      {children}
    </Box>
  );
};
